import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { NavDropdown } from 'react-bootstrap';
import { FaUser, FaUserTie, FaUserCheck } from 'react-icons/fa';
import './UploadAvatar.css';
import logoImage from './NRDRUHSLogo.png';
import NRDRUHSHeader from './NRDRUHSHeader';
import NRDRUHSFooter from './NRDRUHSFooter';

function AdvisoryBoard() {
  const [showMenu, setShowMenu] = useState(false);
  const [scrolling, setScrolling] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setShowMenu(prev => !prev);
  };

  // 🔹 Scroll to top when this page loads or route changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // 🔹 Change navbar on scroll
  useEffect(() => {
    const handleScroll = () => setScrolling(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div>
      {/* NAVBAR */}
      <nav className={`navBar ${scrolling ? 'scrolling' : ''}`} data-aos="fade-down" data-aos-duration="1200">
        <img src={logoImage} alt="Logo" className="logo" />

        <div className="menuButton" onClick={toggleMenu}>
          <div className={`menuIcon ${showMenu ? 'open' : ''}`} />
        </div>

        <ul className={`navLinks ${showMenu ? 'show' : ''}`}>
          <li><Link to="/" className="link">Home</Link></li>
          <li><Link to="/aboutus" className="link">About NRD</Link></li>
          <li><Link to="/issnpage" className="link">ISSN</Link></li>
          <li><Link to="/editorialboard" className="link">Editorial Board</Link></li>
          <li><Link to="#" className="link">Current Issues</Link></li>
          <li><Link to="/publications" className="link">Publications</Link></li>

          <NavDropdown title="Login" id="basic-nav-dropdown" style={{ fontWeight: 'bold' }}>
            <NavDropdown.Item href="/login">
              <FaUser style={{ marginRight: 6, color: 'Navy' }} /> Author
            </NavDropdown.Item>
            <NavDropdown.Item href="/reviewlogin">
              <FaUserTie style={{ marginRight: 6, color: 'Chocolate' }} /> Reviewer
            </NavDropdown.Item>
            <NavDropdown.Item href="/adminlogin">
              <FaUserCheck style={{ marginRight: 6, color: 'green' }} /> Admin
            </NavDropdown.Item>
          </NavDropdown>
        </ul>

        <NavDropdown title="Register" id="register-dropdown" style={{ fontWeight: 'bold', marginRight: 18, backgroundColor: 'red', padding: 15 }}>
          <NavDropdown.Item href="/register">
            <FaUser style={{ marginRight: 6, color: 'Navy' }} /> As an Author
          </NavDropdown.Item>
          <NavDropdown.Item href="/registerreviewer">
            <FaUserTie style={{ marginRight: 6, color: 'red' }} /> As a Reviewer
          </NavDropdown.Item>
        </NavDropdown>
      </nav>

      <NRDRUHSHeader />

      {/* PAGE CONTENT */}
      <div className="container" style={{ paddingTop: 60 }}>
        <h2 className="text-center mb-4" style={{ fontWeight: 'bold' }}>Advisory Board</h2>
      </div>

      <div className="container">
        <div className="row" style={{ marginBottom: 60 }}>
          <div className="col-md-2"></div>

          <div className="text-center mt-4" style={{ color: '#003366', fontSize: '1rem', lineHeight: '1.8' }}>
            <p><strong>Dr. Sankalp Mittal</strong><br />Additional Principal, & Hon. Advisory Board Member, National Research Denticon<br /></p>
            <p><strong>Dr. Manoj Agarwal</strong><br />Additional Principal, & Hon. Advisory Board Member, National Research Denticon<br /></p>
            <p><strong>Dr. Sumit Bhansali</strong><br />Additional Principal, & Hon. Advisory Board Member, National Research Denticon<br /></p>
            <p><strong>Dr. Bharat Sankhla</strong><br />Chief Editor, National Research Denticon<br /></p>
            <p><strong>Dr. Krishna Sireesha S</strong><br />Treasurer & Joint Secretary, National Research Denticon<br /></p>
            <p><strong>Dr. Lalit Likhyani</strong><br />Joint Secretary, National Research Denticon<br /></p>
            <p><strong>Dr. Neha Gupta</strong><br />Joint Secretary, National Research Denticon<br /></p>
            <p><strong>All HOD</strong><br />RUHS College of Dental Sciences, Jaipur<br /></p>
            <p><strong>All the Principals of Affiliated Dental Colleges</strong><br />Rajasthan University of Health Sciences, Jaipur, Rajasthan<br /></p>
          </div>

          <div className="col-md-2" style={{ padding: 15 }}></div>
        </div>
      </div>

      <NRDRUHSFooter />
    </div>
  );
}

export default AdvisoryBoard;
